module.exports = __webpack_public_path__ + "media/icons/ic_debt-3d970633.svg";